import type { OpportunityRecommendation } from "../intelligence";
import type { IntegrationHealth, AutomationCandidate } from "../types/intelligence";

export type { AutomationCandidate };

export function buildAutomationPlan(
  recommendation: OpportunityRecommendation,
  integrationHealth: IntegrationHealth[],
): AutomationCandidate[] {
  const candidates: AutomationCandidate[] = recommendation.automationCandidates.map(
    (item, idx) => ({
      id: `ai-candidate-${idx + 1}`,
      title: item,
      trigger: "on_opportunity_update",
      executionMode: "suggest",
      requiresApproval: true,
    }),
  );

  const connectedIntegrations = integrationHealth.filter(
    (connector) => connector.status === "connected",
  );
  if (connectedIntegrations.length > 0) {
    candidates.push({
      id: "integration-digest",
      title: "Auto-build daily action digest from connected systems",
      trigger: "daily_schedule",
      executionMode: "auto",
      requiresApproval: false,
    });
  }

  if (recommendation.primaryAction.toLowerCase().includes("stage")) {
    candidates.push({
      id: "stage-readiness-watch",
      title: "Run readiness check whenever proof or correspondence changes",
      trigger: "on_evidence_change",
      executionMode: "auto",
      requiresApproval: false,
    });
  }

  if (
    integrationHealth.find((i: IntegrationHealth) => i.id === "gmail" && i.status === "connected")
  ) {
    candidates.push({
      id: "gmail-signal-watch",
      title: "Watch Gmail for new recruiter signals and interview updates",
      trigger: "on_integration_connected",
      executionMode: "auto",
      requiresApproval: true,
    });
  }

  if (
    integrationHealth.find(
      (i: IntegrationHealth) => i.id === "google_calendar" && i.status === "connected",
    )
  ) {
    candidates.push({
      id: "calendar-interview-sync",
      title: "Sync interview schedule and create post-meeting debrief tasks",
      trigger: "on_integration_connected",
      executionMode: "suggest",
      requiresApproval: false,
    });
  }

  if (
    integrationHealth.find(
      (i: IntegrationHealth) => i.id === "linkedin" && i.status === "connected",
    )
  ) {
    candidates.push({
      id: "linkedin-profile-sync",
      title: "Sync LinkedIn experience and check for recruiter DM signals",
      trigger: "on_integration_connected",
      executionMode: "suggest",
      requiresApproval: true,
    });
  }

  return candidates;
}
